// extracted by mini-css-extract-plugin
export var link = "_tc-0";